module.exports = __webpack_public_path__ + "static/img/tab-left.2d1e3af.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/productAndService/bigData/tab-left.png
// module id = e9u4
// module chunks = 1